import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { COLORS } from '../../theme';

const defaultProps = {
  fontWeight: 600,
  color: '#2C2C2C', // Svart enligt styleguide
  fontFamily: 'Poppins, sans-serif',
  fontSize: '12px',
  sx: {}
};

export const H6 = ({ children, fontWeight, color, fontFamily, fontSize, sx }) => {
  return (
    <Typography 
      variant="h6" 
      sx={{ 
        fontWeight: fontWeight || 600, 
        color: color || '#2C2C2C', 
        fontFamily: fontFamily || 'Poppins, sans-serif', 
        fontSize: fontSize || { xs: '11px', md: '12px' },
        marginBottom: '0.5rem', // 8px default spacing
        ...(sx || {}) 
      }}
    >
      {children}
    </Typography>
  );
};

H6.propTypes = {
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sx: PropTypes.object
};

H6.defaultProps = defaultProps;

export default H6;
